module.exports = __webpack_public_path__ + "assets/a531577266ce37a129b6273c7b8384ab.png";